import { Fragment } from 'react';
import { Tab } from '@headlessui/react';
import { oneLine } from 'common-tags';

import { toArray } from '@/lib/utils';

import type { FunctionComponent } from 'react';
import type { TypeTabsProps } from './types';

/**
 * TabGroup
 */
export const Tabs: FunctionComponent<TypeTabsProps> = ({
  classNameTabs,
  children,
  tabs,
  unmount = false,
}: TypeTabsProps) => (
  <Tab.Group as={Fragment}>
    {({ selectedIndex }) => (
      <>
        <Tab.List
          className={`mx-auto flex w-full justify-center overflow-x-auto rounded-lg bg-neutrals-100 p-1 ${classNameTabs}`}
        >
          {tabs.map((item: string, index: number) => (
            <Tab
              key={index}
              className={oneLine`
                text-button w-full py-2 text-primary-500 focus:ring-0 focus:ring-offset-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 md:min-w-[120px]
                ${
                  selectedIndex === index
                    ? 'transition-color rounded bg-primary-500 text-neutrals-50 duration-150'
                    : ''
                }
              `}
            >
              {item}
            </Tab>
          ))}
        </Tab.List>

        <Tab.Panels className="mt-4 w-full">
          {toArray(children)
            .filter(Boolean)
            .map((child, index) => (
              <Tab.Panel unmount={unmount} key={index}>
                {child}
              </Tab.Panel>
            ))}
        </Tab.Panels>
      </>
    )}
  </Tab.Group>
);

Tabs.displayName = 'Tabs';
